import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

interface PageHeadingProps {
  eyebrow: string
  title: string
  /** Right-aligned actions (search, buttons), bottom-aligned with the title. */
  actions?: ReactNode
  /** Artboard 01 draws the title in pure black (`text-ink-strong`); 04 uses navy (default). */
  titleClassName?: string
}

/** Eyebrow + 32px title, as in the artboard 01 / 04 headers. */
export function PageHeading({ eyebrow, title, actions, titleClassName }: PageHeadingProps) {
  return (
    <header className="flex items-end justify-between">
      <div className="flex flex-col gap-1.5">
        <p className="text-label font-medium uppercase tracking-[0.08em] text-ink-muted">{eyebrow}</p>
        <h1 className={cn('text-title font-semibold text-ink', titleClassName)}>{title}</h1>
      </div>
      {actions ? <div className="flex items-center gap-2.5">{actions}</div> : null}
    </header>
  )
}
